import { Column } from 'shared/types/models/EditMetrics';

export function isMarkupBudgetColumn(column: Column) {
  return Boolean(column.kind === 'metric' && column.columnTitle === 'markup');
}
